var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.showMenu())?_c('Menu',{attrs:{"authenticated":this.authenticated}}):_vm._e(),_c('Message',{ref:"msg"}),_c('transition',{attrs:{"name":"body"}},[_c('router-view',{on:{"authenticated":_vm.setAuthenticated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }